// https://vuex.vuejs.org/en/getters.html
import { Ability } from '@casl/ability'

export default {
  token: state => state.user.token,
  name: state => state.user.name,
  role: state => state.user.role,
  loading: state => state.app.loading,
  user: state => state.user,

  accountDialog: state => state.app.accountDialog,
  accountItem: state => state.app.accountItem,

  protocolDialog: state => state.app.protocol_dialog,
  protocolItem: state => state.app.protocol_item,
  siteDialog: state => state.app.site_dialog,
  siteItem: state => state.app.site_item,
  protocolSiteDialog: state => state.app.protocol_site_dialog,
  protocolSiteItem: state => state.app.protocol_site_item,


  snackbar: state => state.app.snackbar,
  ability: () => {
    return new Ability([
      { action: ['read'], subject: ['all'] }
    ])
  },
  changePass: state => state.app.changePass,

  //ISSUE 246
  windowsynchsites: state => state.app.windowsynchsites,
  windowsynchroles: state => state.app.windowsynchroles
  //ISSUE 246
  
}
